/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindTopProductsQueryResponse,
  TelegramProductsControllerFindTopProducts401,
} from '../types/TelegramProductsControllerFindTopProducts.ts';

function getTelegramProductsFindTopProductsUrl() {
  const res = { method: 'GET', url: `/api/telegram/products/top` as const };
  return res;
}

/**
 * {@link /api/telegram/products/top}
 */
export async function telegramProductsFindTopProducts(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindTopProductsQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindTopProducts401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsFindTopProductsUrl().url.toString(), ...requestConfig });
  return res.data;
}
